import { useState } from 'react';
export const useRaceForRewardsPlayer = (autoplay) => {
    const [played, setPlayed] = useState(autoplay);
    const onPlayClick = () => {
        setPlayed(true);
    };
    return {
        played,
        onPlayClick,
    };
};
